import React from "react";
import "./IdeaValidator.css";
import BackgroundImage from "../../assets/images/IdeaValidatorImage.webp";
import { strings } from "../../translations/strings";
import ResponseLoader from "../../common/ResponseLoader";
import TextInput from "../../common/TextInput";
import Disclaimer from "../../common/Disclaimer";
import BackIcon from "../../common/BackIcon";
import FeedbackButtons from "../../common/FeedbackButtons";
import ResponseIcon from "../../assets/icons/IdeaValidator.svg";
import AvatarIcon from "../../assets/images/Avatar.png";
import { transformText } from "../../helpers/functions";
import AskAgainButton from "../../common/AskAgainButton";

const IdeaValidator = ({ data }) => {
  const {
    colors,
    goBack,
    isDarkMode,
    isError,
    isLoading,
    aIResponse,
    userInput,
    handleInputChange,
    onPressButton,
    onPressReset,
    isPressedFeedback,
    setIsPressedFeedback,
  } = data;
  return (
    <div className="idea-validator-container">
      <img
        alt="Background"
        src={BackgroundImage}
        className="idea-validator-background-image"
        draggable={false}
      />
      <div
        className="idea-validator-hairline"
        style={{ backgroundColor: colors.borderColor }}
      />
      <div
        className="idea-validator-content"
        style={{ backgroundColor: colors.componentBackground }}
      >
        <div className="idea-validator-back-icon-container">
          <BackIcon colors={colors} onPress={goBack} isDarkMode={isDarkMode} />
        </div>
        {isLoading ? (
          <ResponseLoader colors={colors} />
        ) : (
          <>
            <span
              className="idea-validator-title"
              style={{ color: colors.primaryText }}
            >
              {strings.idea_validator_title}
            </span>
            <span
              className="idea-validator-text"
              style={{ color: colors.secondaryText }}
            >
              {strings.idea_validator_text}
            </span>
            <div className="idea-validator-disclaimer-container">
              <Disclaimer colors={colors} />
            </div>
            {aIResponse ? (
              <>
                <div
                  className="idea-validator-question-container"
                  style={{ borderColor: colors.borderColor }}
                >
                  <div className="idea-validator-response-icon-and-text">
                    <img
                      alt="Avatar"
                      src={AvatarIcon}
                      draggable={false}
                      className="idea-validator-response-icon"
                    />
                    <span
                      style={{ color: colors.primaryText }}
                      className="idea-validator-response-text"
                    >
                      {userInput}
                    </span>
                  </div>
                </div>
                <div
                  className="idea-validator-response-container"
                  style={{ borderColor: colors.borderColor }}
                >
                  <div className="idea-validator-response-icon-and-text">
                    <img
                      alt="Response"
                      src={ResponseIcon}
                      draggable={false}
                      className="idea-validator-response-icon"
                    />
                    <span
                      style={{
                        color: isError ? "#FF3E3E" : colors.primaryText,
                      }}
                      className="idea-validator-response-text"
                    >
                      {transformText(aIResponse)}
                    </span>
                  </div>
                  {!isError && (
                    <FeedbackButtons
                      isDarkMode={isDarkMode}
                      colors={colors}
                      type={strings.idea_validator_type}
                      isPressed={isPressedFeedback}
                      setIsPressed={setIsPressedFeedback}
                    />
                  )}
                </div>
                <AskAgainButton onPress={onPressReset} />
              </>
            ) : (
              <TextInput
                value={userInput}
                colors={colors}
                handleInputChange={handleInputChange}
                onPressButton={onPressButton}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default IdeaValidator;
